module.exports = __webpack_public_path__ + "static/img/robot.ce4b1520.png";